/**
 * Ancres : repositionnement après chargement (mise en page finale) et au changement de #hash.
 * Les sections cibles utilisent .sp-scroll-anchor + scroll-margin-top dans sapencia.css.
 */
(function () {
  function idFromHash(hash) {
    if (!hash || hash === '#') return '';
    try {
      return decodeURIComponent(hash.slice(1));
    } catch (e) {
      return hash.slice(1);
    }
  }

  function scrollToHash(behavior) {
    var id = idFromHash(window.location.hash);
    if (!id) return;
    var el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: behavior, block: 'start' });
  }

  window.addEventListener('hashchange', function () {
    scrollToHash('smooth');
  });

  window.addEventListener('load', function () {
    if (!window.location.hash || window.location.hash.length < 2) return;
    setTimeout(function () {
      scrollToHash('auto');
    }, 0);
  });
})();
